import React, { useEffect, useState, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import './user-info.scss';

const UserInfoBody = forwardRef(
  (
    {
      left,
      top,
      active,
      mouseEnter,
      mouseLeave,
      direction,
      userName,
      userEmail,
      userRole,
      userUrl,
      shortName,
      updatedOn,
      status,
      byTime,
    },
    ref // Forwarded ref
  ) => {
    const [t] = useTranslation('timeline');
    const [colorCode, setColorCode] = useState('');

    useEffect(() => {
      if (shortName) {
        const colorIns = shortName.split('');
        setColorCode(colorIns?.shift()?.toLowerCase() || '');
      }
    }, [shortName]);

    return ReactDOM.createPortal(
      <div
        className={`user-info ${active ? 'show' : ''} ${
          direction === 'right' ? 'right' : ''
        }`}
        ref={ref} // Forwarded ref applied here
        style={{ left, top }}
        onMouseLeave={mouseLeave}
        onMouseEnter={mouseEnter}
      >
        <div className={`info-user-image ${colorCode}`}>
          {userUrl ? (
            <img src={userUrl} alt="User" />
          ) : (
            <span>{shortName}</span>
          )}
        </div>
        <div className="info-user-details">
          {userName !== '' && <p className="info-user-name">{userName}</p>}
          {userEmail !== '' && <p className="info-user-email">{userEmail}</p>}
          {userRole !== '' && <p className="info-user-role">{userRole}</p>}
          {updatedOn !== '' && <p className="info-user-time">{updatedOn}</p>}
          {status !== '' && (
            <p
              className={`info-user-status ${status}`}
              // ?.toLowerCase()
              // .replace(/\s/g, '-')
              // .replace(/&/g, '-')}`}
            >
              {t(`timelinescreen.${status}`)}
            </p>
          )}
          {byTime !== '' && <p className="info-user-time primary">{byTime}</p>}
        </div>
      </div>,
      document.body
    );
  }
);

UserInfoBody.propTypes = {
  left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  active: PropTypes.bool,
  mouseEnter: PropTypes.func,
  mouseLeave: PropTypes.func,
  direction: PropTypes.string,
  userName: PropTypes.string,
  userEmail: PropTypes.string,
  userRole: PropTypes.string,
  userUrl: PropTypes.string,
  shortName: PropTypes.string,
  updatedOn: PropTypes.string,
  status: PropTypes.string,
  byTime: PropTypes.string,
};

UserInfoBody.defaultProps = {
  left: 0,
  top: 0,
  active: false,
  mouseEnter: () => {},
  mouseLeave: () => {},
  direction: '',
  userName: '',
  userEmail: '',
  userRole: '',
  userUrl: '',
  shortName: '',
  updatedOn: '',
  status: '',
  byTime: '',
};

export default UserInfoBody;
